import React from "react";
import { PropsWithChildren } from "react";
import classNames from "classnames";

type Props = {};

const Layout: React.FC<PropsWithChildren<Props>> = ({ children }) => {
	return <div className={classNames("main-wrapper")}>{children}</div>;
};

export default Layout;
